export * from './delete-projekt-art.service';
export * from './delete-projekt-art.service.module';